const initialPreparePresentationState = {
  fetching: false,
  fetched: false,
  deleted: false,
  deleting: false,
  isVisible: false,
  selectedComponent: "",
  componentComments: [],
  presentationState: "pause",
  slideCommentId: null,
  commentUpdate: "",
  speed: 1,
  firstTime: true,
  progress: 0,
  comment: {
    slideId: "",
    target: "",
    content: "",
    period: "2019"
  },
  items: [],
  error: null,
  nbResult: 0,
  saving: false,
  saved: false,
  extraSlidesInModal: false,
  extraSlideUsable: {
    slideIdClicked: null,
    slideTitle: "",
    slideContent: ""
  }
};
export const PreparePresentationReducer = (
  state = initialPreparePresentationState,
  action
) => {
  switch (action.type) {
    case "INIT_PREPARE_PRESENTATION": {
      return initialPreparePresentationState;
    }
    case "INIT_COMMENT": {
      return {
        ...state,
        comment: {
          slideCode: "",
          target: "",
          content: "",
          period: ""
        }
      };
    }
    case "FETCH_COMMENTS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_COMMENTS_FULFILLED": {
      const { data, nbResult } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data || [],
        nbResult: nbResult
      };
    }

    case `SAVE_COMMENT_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_COMMENT_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true,
        commentUpdate: "",
        selectedComponent: ""
      };
    }
    case `SAVE_COMMENT_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }
    case "DELETE_COMMENT_PENDING": {
      return { ...state, deleted: false, deleting: true };
    }
    case "DELETE_COMMENT_FULFILLED": {
      return { ...state, deleted: true, deleting: false };
    }
    case "DELETE_COMMENT_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
      }
      return {
        ...state,
        saved: false,
        error
      };
    }
    case "SET_COMPONENT_COMMENTS": {
      return {
        ...state,
        componentComments: action.comments
      };
    }
    case "SET_COMMENT_UPDATE": {
      return {
        ...state,
        commentUpdate: action.commentUpdate
      };
    }
    case "SET_FIRST_TIME": {
      return {
        ...state,
        firstTime: action.firstTime
      };
    }
    case "SET_PROGRESS_BAR": {
      return {
        ...state,
        progress: action.progress
      };
    }
    case "SET_DIAPORAMA_SPEED": {
      return {
        ...state,
        speed: action.speed
      };
    }
    case "SET_PRESENTATION_STATE": {
      return {
        ...state,
        presentationState: action.presentationState
      };
    }
    case "SET_SELECTED_COMPONENT": {
      return {
        ...state,
        selectedComponent: action.selectedComponent
      };
    }
    case "ADD_COMMENT": {
      return {
        ...state,
        items: { comments: action.comments }
      };
    }
    case "SET_IS_VISIBLE": {
      return {
        ...state,
        isVisible: action.isVisible
      };
    }
    case "SET_COMMENT_SLIDE_CODE": {
      return {
        ...state,
        comment: { ...state.comment, slideCode: action.slideCode }
      };
    }
    case "SET_TARGET": {
      return {
        ...state,
        comment: { ...state.comment, target: action.target }
      };
    }
    case "SET_COMPONENT_ID": {
      return {
        ...state,
        comment: { ...state.comment, componentId: action.componentId }
      };
    }
    case "ADD_COMMENT_CONTENT": {
      return {
        ...state,
        comment: { ...state.comment, content: action.content }
      };
    }
    case "SET_EXTRA_SLIDES_IN_MODAL_BOOL": {
      return {
        ...state,
        extraSlidesInModal: action.val
      };
    }
    case "SET_EXTRA_SLIDE_USABLE": {
      return {
        ...state,
        extraSlideUsable: action.extraSlideUsable
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/PreparePresentation.js